'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _feiseanna = require('../../../../feiseanna');

var _feiseanna2 = _interopRequireDefault(_feiseanna);

var _registrations = require('../../../../registrations');

var _registrations2 = _interopRequireDefault(_registrations);

var _registrationHistory = require('../../../../registration-history');

var _registrationHistory2 = _interopRequireDefault(_registrationHistory);

var _routerHistory = require('../../../../router-history');

var _routerHistory2 = _interopRequireDefault(_routerHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RegistrationHistoryController = function () {
  function RegistrationHistoryController(participant, account, history, feis, fRouterHistoryService) {
    _classCallCheck(this, RegistrationHistoryController);

    this._ = { participant: participant, fRouterHistoryService: fRouterHistoryService };

    this.feis = feis;
    this.acct = account;
    this.events = history;

    this.person = this._.participant || this.acct;
  }

  _createClass(RegistrationHistoryController, [{
    key: 'back',
    value: function back() {
      this._.fRouterHistoryService.back(true);
    }
  }]);

  return RegistrationHistoryController;
}();

exports.default = angular.module('ifeis.routes.feiseanna.one.registration-history', ['ngMaterial', 'ui.router', 'ifeis.accounts', 'ifeis.router-history', 'ifeis.registration-history', 'ifeis.registrations', 'ifeis.feiseanna']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.registration-history', {
    url: '/registration-history/:participant',
    template: require('./tpl.html'),
    resolve: {
      history: function history($stateParams, account, feis, fRegistrationService) {
        var history = fRegistrationService.for(feis.id).history();
        if (!$stateParams.participant && !account) {
          return false;
        }

        if ($stateParams.participant) {
          return history.one($stateParams.participant);
        }
        return history.all(account.id);
      },
      participant: function participant($stateParams, fAccountService) {
        if (!$stateParams.participant) return;

        return fAccountService.onePerson($stateParams.participant).then(function (person) {
          return person.get();
        });
      }
    },
    controller: 'RegistrationHistoryController',
    controllerAs: 'history',
    ncyBreadcrumb: {
      label: 'Registration History',
      parent: 'feiseanna.one.landing-page'
    }
  });
}).controller('RegistrationHistoryController', RegistrationHistoryController);


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/registration-history/index.js
// module id = 591
// module chunks = 0